export default __webpack_public_path__ + "static/media/aw.2ee03c54.svg";